module.exports = __webpack_public_path__ + "static/media/H_10.d4106ca2.png";